import _filter from "lodash/filter";
import mitt from 'mitt';
export let NotifyAction;

(function (NotifyAction) {
  NotifyAction["SEND"] = "send";
  NotifyAction["DISMISS"] = "dismiss";
})(NotifyAction || (NotifyAction = {}));

export let InternalAction;

(function (InternalAction) {
  InternalAction["REGISTER"] = "register";
})(InternalAction || (InternalAction = {}));

export let MessageType;

(function (MessageType) {
  MessageType["INFO"] = "info";
  MessageType["SUCCESS"] = "success";
  MessageType["WARNING"] = "warning";
  MessageType["ERROR"] = "error";
})(MessageType || (MessageType = {}));

const createNotificationFromPayload = payload => {
  const id = String(Math.random()).substr(2);
  return {
    id,
    type: payload.type || MessageType.INFO,
    body: payload.body,
    timeout: payload.timeout || 0
  };
};

const createNotifier = () => {
  const data = new Map();
  const emitter = mitt();

  const send = payload => {
    emitter.emit(NotifyAction.SEND, {
      payload
    });
  };

  const dismiss = payload => {
    const emitPayload = typeof payload === 'string' ? {
      id: payload
    } : payload;
    emitter.emit(NotifyAction.DISMISS, {
      payload: emitPayload
    });
  };

  emitter.on(NotifyAction.SEND, msg => {
    const notification = createNotificationFromPayload(msg.payload);
    data.set(notification.id, notification);

    if (notification.timeout > 0) {
      setTimeout(() => {
        dismiss(notification.id);
      }, notification.timeout);
    }

    emitter.emit(InternalAction.REGISTER, {
      action: NotifyAction.SEND,
      notification
    });
  });
  emitter.on(NotifyAction.DISMISS, msg => {
    const filtered = _filter(Array.from(data.values()), msg.payload);

    filtered.forEach(notification => {
      data.delete(notification.id);
      emitter.emit(InternalAction.REGISTER, {
        action: NotifyAction.DISMISS,
        notification
      });
    });
  });

  const subscribe = callback => {
    const cb = msg => {
      callback(msg.action, msg.notification);
    };

    emitter.on(InternalAction.REGISTER, cb);
    return () => {
      emitter.off(InternalAction.REGISTER, cb);
    };
  };

  return {
    send,
    info: payload => send({
      type: MessageType.INFO,
      ...payload
    }),
    error: payload => send({
      type: MessageType.ERROR,
      ...payload
    }),
    warning: payload => send({
      type: MessageType.WARNING,
      ...payload
    }),
    success: payload => send({
      type: MessageType.SUCCESS,
      ...payload
    }),
    dismiss,
    subscribe
  };
};

export default createNotifier;